$(() => {
  const gdprContent = $(".aw-gdpr__privacy-policy");
  const gdprContentScroll = $(".aw-gdpr__scrollable-content");

  gdprContentScroll.on("scroll", (event) => {
    var elem = $(event.currentTarget);
    if (elem[0].scrollHeight - elem.scrollTop() == elem.outerHeight()) {
      $(gdprContent).addClass("aw-gdpr__privacy-policy--end");
    } else $(gdprContent).removeClass("aw-gdpr__privacy-policy--end");
  });
});
